import Head from "next/head";

import CreateUsingMacro from "modules/macros/elements/Data-File-Macro-Listing";

const Page = () => {
  const head = (
    <Head>
      <title>Daisho | Create Data Using Macro</title>
    </Head>
  );

  return (
    <>
      <Head>
        <title>Daisho | Create Data Using Macro</title>
      </Head>
      <CreateUsingMacro />
    </>
  );
};

export default Page;
